var loginErrorCtrl = function(restSvc, iFastWebContextRootSvc, $scope, $location,iFastConstants, ssoErrorService){
    "use strict";

     this.restSvc                = restSvc;
     this.iFastWebContextRootSvc = iFastWebContextRootSvc;
     this.scope                  = $scope;
     this.location               = $location;
     this.iFastConstants         = iFastConstants;
     this.ssoErrorService        = ssoErrorService;
     this.loadClientLoginSetting();
};

loginErrorCtrl.prototype.loadClientLoginSetting = function (redirect) {
    "use strict";

    var clientCd = this.iFastWebContextRootSvc.clientCode;
    var rest     = this.restSvc.query({type: "configuration", method: "retrieveClientLoginSetting"}, {"clientCd" : clientCd});
    rest.$promise.then(this.passClientLoginSetting(this, redirect), this.fail(this));
};

loginErrorCtrl.prototype.passClientLoginSetting = function (ctrl) {
    "use strict";

    return function (result) {
        ctrl.userAdminSettingMap = result.userAdminSettingMap;
        ctrl.language= ctrl.userAdminSettingMap.language || navigator.language.substr(0, navigator.language.indexOf("-"))   ;
        var errorMessage = result.userAdminSettingMap[ctrl.iFastConstants.SSO_LOGIN_ERROR_MSG_CODE];
       
        if (errorMessage) {
        	ctrl.scope.errorMessage  = errorMessage;
        } else {
            ctrl.handleErrorMsg(ctrl);
        }
        ctrl.isLoaded = true;
    };
};

loginErrorCtrl.prototype.fail = function (ctrl) {
    "use strict";

    return function () {
        ctrl.handleErrorMsg(ctrl);
    };
};

loginErrorCtrl.prototype.handleErrorMsg = function (ctrl) {
    "use strict";

    var clientCd = ctrl.iFastWebContextRootSvc.clientCode;
    var langCd = navigator.language || navigator.userLanguage;
    if(ctrl.userAdminSettingMap) {
        langCd = ctrl.userAdminSettingMap.language || langCd.substr(0, langCd.indexOf("-"));
    } else {
        langCd = langCd.substr(0, langCd.indexOf("-"));
    }
    ctrl.scope.errorMessage = ctrl.ssoErrorService.getError(clientCd, langCd);
    ctrl.isLoaded = true;
};

loginErrorCtrl.$inject = ["restSvc", "iFastWebContextRootSvc",  "$scope", "$location","iFastConstants", "ssoErrorService"];
    angular
        .module("iFAST.loginError")
        .controller("loginErrorCtrl", loginErrorCtrl);




// WEBPACK FOOTER //
// ./WebContent/src/login/ifastLogin-error-controller.js